
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let u = navigator.userAgent;
		let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
		let device= isAndroid?"H5_ANDROID":"H5_IOS"

		let APIS = {
			// 获取活动开始时间或者结束时间
			getCountdownTime: {
				custom: true,
				url: (data:any)=>`/apis/moyin-account/v1/marketingcenter/vip-day/countdown`,
				method: 'get'
			},
			getPurchaseMsg: {
				custom: true,
				url: (data:any)=>`/apis/moyin-account/v1/marketingcenter/vip-day/purchase/msg`,
				method: 'get'
			},
			getVipDayPage: `/apis/moyin-account/v1/marketingcenter/vip-day/page`,
			getUser: {
				custom: true,
				url: (data:any)=>`/apis/moyin-account/v1/user?device=${device}`,
				method: 'get'
			},

		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"memberDayPage"
			})
		}